// General
import React from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Register.css';
// Components
import RegisterForm from '../../components/RegisterForm';
// Translation
import { injectIntl } from 'react-intl';

const Register = ({ title, refer, intl }) => {
  let initialValues = {}, socialLoginRefer, loginURL = '/login';

  if (refer) {
    initialValues = {
      refer
    };
    socialLoginRefer = refer;
    if (socialLoginRefer) {
      socialLoginRefer = socialLoginRefer.includes('?')
        ? socialLoginRefer.replaceAll('?', '------')
        : socialLoginRefer;
      socialLoginRefer = socialLoginRefer.includes('&')
        ? socialLoginRefer.replaceAll('&', '--')
        : socialLoginRefer;
    }

    loginURL = `/login?refer=${refer}`;
  }

  return (
    <div className={s.root}>
      <div className={s.container}>
        <RegisterForm initialValues={initialValues} loginURL={loginURL} refer={socialLoginRefer} />
      </div>
    </div>
  );
};

Register.propTypes = {
  title: PropTypes.string.isRequired,
  refer: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(withStyles(s)(Register));